import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"play, go"} maskId="square-filled-radius-0-stroke-1-IconPlay"><path d="M5 2V22L22 12L5 2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPlay;
